export class DefineRangeTypeErrorResponse {
  name: any;
  statisticalMethod: any;
}
